import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import doumentService from "../../services/doument-vendor";
import customerInfoServices from "../../services/customer-profile-services";
import { toast } from "react-toastify";
import { handleErrors } from "../../utils/errorHandler";
const MyDocuments = () => {
  const [formData, setFormData] = useState({
    GSTNo: "",
    PANNo: "",
    GSTFile: null,
    PANFile: null,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: file,
        ...(name === "PANFile" && {
          PANFilePreview: URL.createObjectURL(file),
        }),
        ...(name === "GSTFile" && {
          GSTFilePreview: URL.createObjectURL(file),
        }),
      }));
    }
  };
  const validateForm = () => {
    let newErrors = {};

    if (!formData.GSTNo) {
      newErrors.GSTNo = "GST Number is required";
    } else if (
      !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{3}$/.test(formData.GSTNo)
    ) {
      newErrors.GSTNo = "Invalid GST Number format.";
    }

    if (!formData.PANNo) {
      newErrors.PANNo = "PAN Number is required";
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.PANNo)) {
      newErrors.PANNo = "Invalid PAN Number format.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  async function fetchProfileData() {
    try {
      const response = await customerInfoServices.getVendorProfileInfo();
      const data = response.data.result;

      setFormData({
        GSTNo: data.vendorBusinessInfo?.gstNo || "",
        PANNo: data.vendorBusinessInfo?.panNo || "",
        GSTFile: data.vendorBusinessInfo?.gstFile || "",
        PANFile: data.vendorBusinessInfo?.panFile || "",
        GSTFilePreview: data.vendorBusinessInfo?.gstFile || "",
        PANFilePreview: data.vendorBusinessInfo?.panFile || "",
      });
    } catch (error) {
      toast.error(handleErrors(error));
    }
  }

  useEffect(() => {
    fetchProfileData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const payload = new FormData();
      payload.append("GSTNo", formData.GSTNo);
      payload.append("PANNo", formData.PANNo);
      if (formData.GSTFile) payload.append("GSTFile", formData.GSTFile);
      if (formData.PANFile) payload.append("PANFile", formData.PANFile);

      try {
        const response = await doumentService.submitDoumentForm(payload);
        if (response.status === 200) {
          toast.success("Form submitted successfully!");
        }
      } catch (error) {
        console.error("Error submitting document form:", error);
        toast.error("Failed to submit form. Please try again.");
      }
    }
  };

  return (
    <div className="container mt-4">
      <h2>My Documents</h2>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} xl={6} lg={6} sm={6}>
            <Form.Group className="form-group">
              <Form.Label>
                GST No<span className="imp-star">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter GST No"
                name="GSTNo"
                value={formData.GSTNo}
                onChange={handleChange}
                isInvalid={!!errors.GSTNo}
              />
              <Form.Control.Feedback type="invalid">
                {errors.GSTNo}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col xs={12} xl={6} lg={6} sm={6}>
            <Form.Group className="form-group">
              <Form.Label>
                PAN No<span className="imp-star">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter PAN No"
                name="PANNo"
                value={formData.PANNo}
                onChange={handleChange}
                isInvalid={!!errors.PANNo}
              />
              <Form.Control.Feedback type="invalid">
                {errors.PANNo}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <div className="col-lg-6 mb-3">
            <label>GST File</label>
            <div
              style={{
                border: "1px dashed #868686",
                padding: "10px",
                textAlign: "center",
                borderRadius: "5px",
              }}
            >
              <input
                type="file"
                name="GSTFile"
                className="form-control"
                onChange={handleFileChange}
                style={{ display: "none" }}
                id="GSTFile"
              />
              <label
                className="mb-0 resume-upload"
                htmlFor="GSTFile"
                style={{ cursor: "pointer" }}
              >
                <p className="mt-0 mb-0">+ Add or Drop Files Here</p>
              </label>
            </div>
            {formData.GSTFilePreview && (
              <img
                src={formData.GSTFilePreview}
                alt="GST Preview"
                style={{
                  width: "100px",
                  height: "auto",
                  marginTop: "10px",
                }}
              />
            )}
          </div>
          <div className="col-lg-6 mb-3">
            <label>PAN File</label>
            <div
              style={{
                border: "1px dashed #868686",
                padding: "10px",
                textAlign: "center",
                borderRadius: "5px",
              }}
            >
              <input
                type="file"
                name="PANFile"
                className="form-control"
                onChange={handleFileChange}
                style={{ display: "none" }}
                id="PANFile"
              />
              <label
                className="mb-0 resume-upload"
                htmlFor="PANFile"
                style={{ cursor: "pointer" }}
              >
                <p className="mt-0 mb-0">+ Add or Drop Files Here</p>
              </label>
            </div>
            {formData.PANFilePreview && (
              <img
                src={formData.PANFilePreview}
                alt="PAN Preview"
                style={{
                  width: "100px",
                  height: "auto",
                  marginTop: "10px",
                }}
              />
            )}
          </div>
        </Row>

        <Button type="submit" className="btn pay-now-btn mt-3">
          Submit
        </Button>
      </Form>
    </div>
  );
};

export default MyDocuments;
